import React from 'react'
import { X } from 'react-bootstrap-icons'

const HideButton = ({
    onClick = () => {}
}) => {
    return (
        <div
            style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                zIndex: '100',
                
            }}
        >
            <div style={{ color: 'rgb(0, 123, 255)', cursor: 'pointer' }} onClick={() => onClick()}>
                <X size={30} />
            </div>
        </div>
    )
}

export default HideButton